import { type IMenuData, type ISiteInfo } from "@/types/types";
import once from "lodash/once";
import { traverseMenuTree } from "@/utils";
import { getAppInfo, ytFetch } from "@/services";
import MOCK_MENU from "./mock/menu";
import MOCK_SITE_INFO from "./mock/siteinfo";

interface ApiResponse {
  menus: IMenuData;
  siteInfo: ISiteInfo;
}

/**
 * 异步请求getMenuByRequest
 */
export const getMenuByRequest = once(
  async ({ appCode }): Promise<ApiResponse> => {
    return ytFetch.get("/api/menu/find", { appCode });
  },
);

/**
 * 获取菜单数据的方法
 */
export const getMenus = once(async (): Promise<ApiResponse> => {
  let res: ApiResponse;
  try {
    const appInfo = await getAppInfo();
    const { appCode, appName, appLogo } = appInfo;
    const menuData = await getMenuByRequest({ appCode });

    // 补结构并做一些数据处理
    const menus = { children: menuData };
    traverseMenuTree(menus, (node) => {
      // 把空 children 过滤掉 TODO: 最合理的应该服务端去掉
      if (node.children && node.children.length === 0) {
        delete node.children;
      }
      // key前面补 "/" TODO: 确认是否用path当路径
      if (node.key && !node.key.startsWith("/")) {
        node.key = `/${node.key}`;
      }
    });

    res = {
      menus,
      siteInfo: { appName, appLogo },
    };
  } catch {
    // TODO: 请求失败时, 暂时用mock数据替代
    res = {
      menus: MOCK_MENU as IMenuData,
      siteInfo: MOCK_SITE_INFO as ISiteInfo,
    };
  }
  return res;
});
